import React, { Component } from 'react';
import editorZoneStyles from './editor-zone.less.js';
import { withState } from '../../services/store/with-state.js';
import { BuiltinUiState } from '../../services/store/builtin-state.js';
import { WorkbenchConfigurationState } from '../../services/settings/auto-sync-settings.js';
import { Grid } from './grid.js';
import { Widget } from '../widget/widget.js';
import { groupBy } from '../../utils/array-utils.js';

class EditorZoneComponent extends Component {
    render() {
        var _a, _b, _c, _d;
        const widgets = groupBy(this.props.floatWidget, 'layer', 'upper');
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, Object.assign({}, this.props.surface, { mode: this.props.mode, className: editorZoneStyles['editor-zone'], style: {
                    paddingLeft: this.props['editorZone.paddingLeft'],
                    paddingRight: this.props['editorZone.paddingRight'],
                    paddingTop: this.props['editorZone.paddingTop'],
                    paddingBottom: this.props['editorZone.paddingBottom'],
                    marginLeft: this.props.editorZoneMarginLeft,
                    marginRight: this.props.editorZoneMarginRight,
                } })),
            React.createElement(Grid, Object.assign({}, this.props.floatSurface, { mode: this.props.mode, style: Object.assign({ display: (((_b = (_a = this.props.floatSurface.surfaces) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 || ((_d = (_c = this.props.floatSurface.grids) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0) ? 'block' : 'none', zIndex: 1300 }, this.props.floatSurfaceStyle) })),
            Object.keys(widgets).map((layer) => {
                const layerWidgets = widgets[layer];
                return React.createElement("div", { key: layer, id: layer !== 'upper' ? `workbench-float-widgets-${layer}` : 'workbench-float-widgets', className: editorZoneStyles['float-widgets'], style: {
                        marginLeft: this.props.editorZoneMarginLeft,
                        marginRight: this.props.editorZoneMarginRight,
                    } }, layerWidgets.map(widget => {
                    var _a;
                    return React.createElement(Widget, Object.assign({ key: `float-${widget.name}`, style: widget.styles, visibilityTransition: widget.visibilityTransition }, widget.props, { visible: (_a = widget.visible) !== null && _a !== void 0 ? _a : true }), widget.component);
                }));
            })));
    }
}
const EditorZone = withState([
    BuiltinUiState.Surface,
    BuiltinUiState.FloatSurface,
    BuiltinUiState.FloatSurfaceStyle,
    BuiltinUiState.FloatWidget,
    BuiltinUiState.EditorZoneMarginLeft,
    BuiltinUiState.EditorZoneMarginRight,
    WorkbenchConfigurationState.PaddingLeft,
    WorkbenchConfigurationState.PaddingRight,
    WorkbenchConfigurationState.PaddingTop,
    WorkbenchConfigurationState.PaddingBottom,
], true)(EditorZoneComponent);

export { EditorZone };
//# sourceMappingURL=editor-zone.js.map
